import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import i18n from 'i18n-react';

import ContestCard from 'components/ContestCard';

import APIHandler from 'config/APIHandler';

import Badge from 'views/BadgeView/IncentiveBadge';

/**
 * View to display a single (badge) incentive, that forwards to the associated page.
 *
 * @param root0
 * @param root0.match
 * @returns {JSX.Element}
 */
const SubappsViewNew = ({ match }) => {
  const [incentive, setIncentive] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentContainerClasses = clsx('content-container', 'badge');
  const { id } = match.params; // Deconstructing id directly from match.params

  useEffect(() => {
    if (id) {
      APIHandler.getIncentive(id)
        .then((data) => {
          setIncentive(data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setIsLoading(false);
        });
    } else {
      setError('No incentive ID provided.');
      setIsLoading(false);
    }
  }, [id]); // Added id as a dependency to useEffect

  if (isLoading) {
    return <p>{'Loading...'}</p>;
  }

  if (error) {
    return (
      <p>
        {'Error: '}
        {error}
      </p>
    );
  }

  const { title, description, terms, image, url, micro_app_id: microAppId } = incentive;
  return (
    <div className="contentContainer incentiveView">
      <div className={contentContainerClasses}>
        <ContestCard key={id} title={title} description={description} terms={terms} image={image} />
        {microAppId && (
          <div key={id} className="dash-badge">
            <Badge badgeImg={image} title={title} rounded lockLinkUrl={url} microAppId={microAppId} />
          </div>
        )}
        {incentive.length === 0 && (
          <div className="noDashBadge">
            <p>{i18n.translate('rewards.dashboardView.noBadgeIncentives')}</p>
            <br />
          </div>
        )}
      </div>
    </div>
  );
};

export default SubappsViewNew; // Corrected the export to match the component name
